import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { InputDateField } from '@/components';
import { Nullable } from 'primereact/ts-helpers';
import styles from './DocumentsHistoryFilter.module.scss';
import { TableFilters } from '../../types';

type DocumentsWebTableFiltersProps = {
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
};

const DocumentsWebFilters: FC<DocumentsWebTableFiltersProps> = ({
  filters,
  setFilters,
}) => {
  const { t } = useTranslation('tableFilters');

  const handleFilterChange = (
    value: string | Nullable<Date>,
    field: keyof TableFilters
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };

    setFilters(newFilters);
  };

  const today = new Date();

  return (
    <div className={styles.filtersContainer}>
      <InputDateField
        id="startAt"
        name="startAt"
        value={filters.fechaDesde}
        onChange={(e) => handleFilterChange(e, 'fechaDesde')}
        label={t('startAt')}
        className={styles.dateField}
        readOnlyInput
        maxDate={today}
      />
      <InputDateField
        id="endAt"
        name="endAt"
        value={filters.fechaHasta}
        onChange={(e) => handleFilterChange(e, 'fechaHasta')}
        label={t('endAt')}
        className={styles.dateField}
        readOnlyInput
        maxDate={today}
      />
    </div>
  );
};

export default DocumentsWebFilters;
